import LL55ScanSurvey from "../../pages/LL55SurveyScan";
import SurveyEntry from "../../pages/SurveyScan";
import PrivacyPolicy from "../../pages/PrivacyPolicy";

export const Public = [
  {
    path: "/lead-compliance-form",
    element: <SurveyEntry />,
  },
  {
    path: "/ll55-survey-scan",
    element: <LL55ScanSurvey />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
];
